/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var ServicesUtils = require('ES/utils/ServicesUtils');
var HorizontalFields = require('ES/widgets/HorizontalFields');
var AuthedUserSession = require('../../../utils/AuthedUserSession');

module.exports = dd.createClass({
	mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_SalesForce_config", "save_Thirdpartyconnection_SalesForce_config")],
	__RadioAjax_key_read_Thirdpartyconnection_SalesForce_config: function(){
		return this.state.sid;
	},
	__RadioAjax_key_save_Thirdpartyconnection_SalesForce_config: function(){
		this.setState({has_connected: true});
		return this.state.sid;
	},
	getInitialState: function(){
		return {sid: -1, has_connected: null, is_reading: false, read_error_msg: null, show_disconnect: false};
	},
	componentWillMount: function () {
		var self = this;
		self.radio = {
			save_Thirdpartyconnection_SalesForce_config: function (sid) {
				if (self.state.sid === sid) {
					self.setState({has_connected: null, is_reading: true, read_error_msg: null});
				}
			},
			save_Thirdpartyconnection_SalesForce_config_succeeded: function (sid, has_it) {
				if (self.state.sid === sid) {
					self.setState({has_connected: !!has_it, is_reading: false, read_error_msg: null});
				}
			},
			save_Thirdpartyconnection_SalesForce_config_failed: function (sid, message) {
				if (self.state.sid === sid) {
					self.setState({has_connected: null, is_reading: false, read_error_msg: 'Failed to read your Salesforce connector settings: ' + message});
				}
			}
		};
	},
	componentWillReceiveProps: function(props){
		this.__loadForSid(props.selected_sid);
	},
	componentDidMount: function(){
		this.__loadForSid(this.props.selected_sid);
	},
	__loadForSid: function(sid){
		if(sid !== this.state.sid){
			this.setState({sid: sid}, function(){
				radio('read_Thirdpartyconnection_SalesForce_config').broadcast(sid);
			});
		}
	},
	__onSubmit: function(data){
		radio('save_Thirdpartyconnection_SalesForce_config').broadcast(this.state.sid, data);
	},
	render: function(){
		var Displaylists = this.props.Displaylists;

		var sid = this.state.sid;
		var has_connected = this.state.has_connected;
		var ajax_read = this.state.read_Thirdpartyconnection_SalesForce_config;
		var ajax_save = this.state.save_Thirdpartyconnection_SalesForce_config;

		var speaker = _.find(Displaylists && Displaylists.perspeaker, function(spkr){
			return spkr.sid == sid;
		}, this);

		return dd.div(null,
			LoadingWrap({
					is_loading: ajax_read.waiting || ajax_save.waiting,
					glass: true
				},
				dd.h3(null, 'SalesForce connector for ',
					dd.span({className: 'nametag'},
						AuthedUserSession.MY_USERNAME),
					' + ',
					dd.span({className: 'nametag'},
						speaker ? speaker.name_full : '')
				),
				dd.p({className: 'text-muted'},
					'NOTE: The settings for this connector is PER-USER. Each user on the account must individually use this configuration page.'
				),
				ErrorAlert({message: ajax_read.error_message}),
				ErrorAlert({message: ajax_save.error_message}),
				DaForm({
					sid: sid,
					config: ajax_read.data,
					onSubmit: this.__onSubmit
				}),
				(has_connected ? dd.div({className: 'alert alert-success'}, 'You are connected to Salesforce!') : null)
			)
		);
	}
});

var DaForm = dd.createClass({
	mixins: [FormMixin],
	getInitialValuesSourceVersion: function(props){
		return props.sid + JSON.stringify(this.getInitialValues(props));
	},
	getInitialValues: function(props){
		var config = props.config || {};
		return {
			salesforce_username: config.salesforce_username || '',
			salesforce_password: config.salesforce_password || '',
			salesforce_api_token: config.salesforce_api_token || ''
		};
	},
	buildFields: function(){
		return {
			salesforce_username: {
				label: 'SalesForce username',
				type: 'text',
				help_text: 'example: you@domain.com',
				tooltip: 'This is the username for your SalesForce account.'
			},
			salesforce_password: {
				label: 'SalesForce password',
				type: 'text',
				help_text: '(cASE sENSITIVE)',
				tooltip: 'Enter the password you use to access your SalesForce account. This is CASE SENSITIVE.'
			},
			salesforce_api_token: {
				label: 'API Token',
				type: 'text',
				help_text: 'example: 023eb09d953408',
				tooltip: 'Input the SalesForce API token. You can find this in SalesForce in SETTINGS -> SECURITY TOKEN.'
			}
		};
	},
	__discardChanges: esUtils.wrapPreventDefault(function(){
		this._form_reset();
	}),
	render: function(){
		var fields = this.buildFields();
		var errors = this.state.errors || {};

		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}),
			HorizontalFields.FormButtons({onDiscard: this.__discardChanges})
		);
	}
});


// WEBPACK FOOTER //
// ./src/components/account_settings/connect/SalesForce.js